import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { checklistsClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useChecklistsState = () => React.useContext(Context) || {}
export const useChecklists = () => useChecklistsState()?.checklists || []

const QUERY = gql`
  query Checklists($page: Int, $search: String, $filter: ChecklistFilter) {
    checklists(
      page: $page
      search: $search
      sort: [{ field: PROJECT_NAME }, { field: NAME }]
      fromTemplates: true
      filter: $filter
    ) {
      id
      name
      icon
      description
      updatedAt
      project {
        id
        name
        color
      }
    }
  }
`

const ChecklistsLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()
  const filter = useCleanFilterForRequest()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      filter: { ...filter }
    },
    // fetchPolicy: 'network-only',
    client: checklistsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren} empty={false}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading} />
      </StatePresenter>
    </Provider>
  )
}

export default ChecklistsLoader
